import React from "react";

export default function MPHome() {
  return <div>MPHome</div>;
}
